import { render } from "./ProjectSave.vue?vue&type=template&id=f0990e9a&scoped=true"
import script from "./ProjectSave.vue?vue&type=script&lang=js"
export * from "./ProjectSave.vue?vue&type=script&lang=js"

import "./ProjectSave.vue?vue&type=style&index=0&id=f0990e9a&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0990e9a"]])

export default __exports__